export default function applyFavicon(logoCircle) {
  if (!logoCircle) return;

  const icon = document.querySelector('link[rel="icon"]');
  const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');

  if (icon) icon.href = logoCircle;
  if (appleIcon) appleIcon.href = logoCircle;
}
